<template>
  <Loader :value="promise" class="project-custom-field-schemas">
    <div v-for="item in filteredSchemas" :key="item.id" class="row">
      <ButtonComponent
        :label="fields[item.id]"
        :icon="['fal', 'plus']"
        @click="$emit('add', item)"
        style="background-color: white"
      />
      <HelperPopover :template="item.id" />
    </div>
  </Loader>
</template>

<script>
import graphql from '@/api/graphql'
import Query from '@/api/graphql/queries/CustomFieldSchemas.gql'

import HelperPopover from '@/components/HelperPopover/Component'

export default {
  props: {
    exclude: {
      type: Array,
      default: () => [],
    },
    include: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      schemas: [],
      promise: null,
      fields: {
        'additional-info.json': this.$t('nearbyarea'),
        'subpages.json': this.$tc('subpage', 2),
        'residential-templates.json': this.$t('customFieldsUnitCatalogLabel'),
        'footer-content.json': this.$t('footer'),
        'social-media.json': this.$t('socialMedia'),
        'seo.json': this.$t('SEO'),
        'facebook-ads.json': this.$t('facebookAds'),
        'privacy-policy.json': this.$t('privacyPolicyTitle'),
      },
    }
  },
  computed: {
    filteredSchemas() {
      return this.schemas.filter(schema => {
        if (!Object.keys(this.fields).includes(schema.id)) return false
        if (this.exclude.map(e => e.source).includes(schema.id)) return false
        if (this.include.length) return this.include.map(e => e.source).includes(schema.id)
        return true
      })
    },
  },
  methods: {
    fetch() {
      this.promise = graphql
        .request(Query, { ids: Object.keys(this.fields) })
        .then(data => (this.schemas = data.CustomFieldSchemas))
    },
  },
  created() {
    this.fetch()
  },
  components: {
    HelperPopover,
  },
}
</script>

<style lang="scss">
.project-custom-field-schemas {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;

  .elder-button {
    border-radius: 20px;
  }
}
</style>
